import src from '../assets/bunkerswv.png';
import { imageLogo } from './imageLogo';

export const BunkersWvLogo = imageLogo({
  src,
  width: 513,
  height: 240,
  alt: 'Bunkers',
});
